import "index.scss";
import "./navbar";

// Import all JavaScript & CSS files from src/_components
const componentsContext = require.context(
  "bridgetownComponents",
  true,
  /\.(js|css)$/
);
componentsContext.keys().forEach(componentsContext);
